<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">List</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-list" />
            Vehicles > List
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="p-3">
        <CRow class="mt-1" alignHorizontal="center">
          <CCol class="col-4">
            <b-input-group class="mt-3">
              <b-form-input v-model="searchValue" placeholder="Search vehicle plate"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="searchVehicle"><CIcon name="cil-magnifying-glass" /></b-button>
              </b-input-group-append>
            </b-input-group>
            <!-- <b-form-input 
              v-model="searchValue"
              class="ml-2">
            </b-form-input>
            <CButton color="primary" type="submit" style="width:7rem" :disabled="isSearching" @click="generateReport">
              <b-spinner small v-if="isSearching" />
              {{ isSearching ? 'Searching...' : 'Search' }}
            </CButton> -->
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <CButton 
              @click="collapse = !collapse" 
              color="primary"
              class="mb-2"
            >
              <CIcon name="cil-filter" /> Filter
            </CButton>
            <CCollapse :show="collapse">
              <CCard body-wrapper>
                <CRow class="mb-3">
                  <CCol col="4">
                    <b-form-checkbox 
                      v-model="disableVehicleType" 
                      name="vehicle-type-switch" 
                      switch>
                      Vehicle Type
                    </b-form-checkbox>
                  </CCol>
                  <CCol col="8">
                    <b-form-checkbox-group
                      v-model="selected"
                      :options="options"
                      value-field="item"
                      text-field="name"
                      :disabled="!disableVehicleType"
                    ></b-form-checkbox-group>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="4">
                    <b-form-checkbox v-model="disableFirstTrackTime" name="first-track-switch" switch>
                      First Tracked Time
                    </b-form-checkbox>
                  </CCol>
                  <CCol col="4">
                    <b-form-group
                      invalid-feedback="This input is required."
                      :state="firstTrackTime.periodFrom.isValid"
                    >
                      <b-input-group prepend="From">
                        <b-form-datepicker
                          v-model="firstTrackTime.periodFrom.value" 
                          :max="firstTrackTime.periodFrom.maxValue"
                          id="report-periodFrom"
                          placeholder="DD/MM/YYYY"
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                          locale="id"
                          :state="firstTrackTime.periodFrom.isValid"
                          :disabled="!disableFirstTrackTime"
                        ></b-form-datepicker>
                        <b-form-timepicker
                          v-model="firstTrackTime.periodFrom.timeValue"
                          now-button
                          locale="id"
                          :disabled="!disableFirstTrackTime"
                        ></b-form-timepicker>
                      </b-input-group>
                    </b-form-group>
                  </CCol>
                  <CCol col="4">
                    <b-form-group
                      invalid-feedback="This input is required."
                      :state="firstTrackTime.periodTo.isValid"
                    >
                      <b-input-group prepend="To">
                        <b-form-datepicker
                          v-model="firstTrackTime.periodTo.value" 
                          :max="firstTrackTime.periodTo.maxValue"
                          id="report-periodTo"
                          placeholder="DD/MM/YYYY"
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                          locale="id"
                          :state="firstTrackTime.periodTo.isValid"
                          :disabled="!disableFirstTrackTime"
                        ></b-form-datepicker>
                        <b-form-timepicker
                          v-model="firstTrackTime.periodTo.timeValue"
                          now-button
                          locale="id"
                          :disabled="!disableFirstTrackTime"
                        ></b-form-timepicker>
                      </b-input-group>
                    </b-form-group>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="4">
                    <b-form-checkbox v-model="disableLastTrackTime" name="last-track-switch" switch>
                      Last Tracked Time
                    </b-form-checkbox>
                  </CCol>
                  <CCol col="4">
                    <b-form-group
                      invalid-feedback="This input is required."
                      :state="lastTrackTime.periodFrom.isValid"
                    >
                      <b-input-group prepend="From">
                        <b-form-datepicker
                          v-model="lastTrackTime.periodFrom.value" 
                          :max="lastTrackTime.periodFrom.maxValue"
                          id="report-periodFrom"
                          placeholder="DD/MM/YYYY"
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                          locale="id"
                          :state="lastTrackTime.periodFrom.isValid"
                          :disabled="!disableLastTrackTime"
                        ></b-form-datepicker>
                        <b-form-timepicker
                          v-model="lastTrackTime.periodFrom.timeValue"
                          now-button
                          locale="id"
                          :disabled="!disableLastTrackTime"
                        ></b-form-timepicker>
                      </b-input-group>
                    </b-form-group>
                  </CCol>
                  <CCol col="4">
                    <b-form-group
                      invalid-feedback="This input is required."
                      :state="lastTrackTime.periodTo.isValid"
                    >
                      <b-input-group prepend="To">
                        <b-form-datepicker
                          v-model="lastTrackTime.periodTo.value" 
                          :max="lastTrackTime.periodTo.maxValue"
                          id="report-periodTo"
                          placeholder="DD/MM/YYYY"
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                          locale="id"
                          :state="lastTrackTime.periodTo.isValid"
                          :disabled="!disableLastTrackTime"
                        ></b-form-datepicker>
                        <b-form-timepicker
                          v-model="lastTrackTime.periodTo.timeValue"
                          now-button
                          locale="id"
                          :disabled="!disableLastTrackTime"
                        ></b-form-timepicker>
                      </b-input-group>
                    </b-form-group>
                  </CCol>
                </CRow>
              </CCard>
            </CCollapse>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              :per-page="table.perPage"
              :current-page="table.currentPage"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(index)="data">
                {{ data.index + 1 + ((table.currentPage-1)*10) }}
              </template>
              <template #cell(vehicle_type)="row">
                {{ row.item.vehicle_type.charAt(0).toUpperCase() + row.item.vehicle_type.slice(1) }}
              </template>
              <template #cell(date)="row">
                {{ $helper.showData(row.value, "longDateWithTime") }}
              </template>
              <template #cell(camera)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(actions)="row">
                <CButton size="sm" color="secondary" style="color: white; margin-right: 0.5rem !important;" @click="getDetail(row.item)" class="btn-icon mr-2 custom-button-action">
                  Details
                </CButton> 
                <CButton size="sm" color="secondary" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="trackItem(row.item.plate_number)">
                  Track
                </CButton> 
              </template>
            </b-table>
            <CCardFooter>
              <b-row>
                <b-col md="8" cols="12">
                  <div class="my-2">{{ table.totalViewText }}</div>
                </b-col>
                <b-col md="4" cols="12">
                  <b-pagination class="mb-0" align="right"
                    v-model="table.currentPage"
                    :total-rows="table.totalRows"
                    :per-page="table.perPage"
                  />
                </b-col>
              </b-row>
            </CCardFooter>
          </CCol>
        </CRow>

      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showDetailModal" :centered="true">
        <div slot="header"><h5>View Vehicle Detail</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                label="Plate Number"
                label-for="plate-number"
              >
                <b-form-input
                  v-model="detail.plate_number"
                  id="plate-number"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Type"
                label-for="vehicle-type"
              >
                <b-form-input
                  v-model="detail.vehicle_type"
                  id="vehicle-type"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Camera"
                label-for="camera"
              >
                <b-form-input
                  v-model="detail.camera"
                  id="camera"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="First Tracked Time"
                label-for="first-tracked-time"
              >
                <b-form-input
                  v-model="detail.first_tracked_time"
                  id="first-tracked-time"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Last Tracked Time"
                label-for="last-tracked-time"
              >
                <b-form-input
                  v-model="detail.last_tracked_time"
                  id="last-tracked-time"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Confidence"
                label-for="plate-confidence"
              >
                <b-form-input
                  v-model="detail.plate_confidence"
                  id="plate-confidence"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.plate_image_in != null">
            <CCol sm="12" class="mb-2">
              <label>Plate Number Vehicle In:</label>
              <b-img thumbnail fluid-grow :src="detail.plate_image_in" alt="plate-vehicle-in"></b-img>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.vehicle_image_in != null">
            <CCol sm="12" class="mb-2">
              <label>Vehicle In:</label>
              <b-img thumbnail fluid-grow :src="detail.vehicle_image_in" alt="vehicle-in"></b-img>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.plate_image_out != null">
            <CCol sm="12" class="mb-2">
              <label>Plate Number Vehicle Out:</label>
              <b-img thumbnail fluid-grow :src="detail.plate_image_out" alt="plate-vehicle-out"></b-img>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.vehicle_image_out != null">
            <CCol sm="12" class="mb-2">
              <label>Vehicle Out:</label>
              <b-img thumbnail fluid-grow :src="detail.vehicle_image_out" alt="vehicle-out"></b-img>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showDetailModal = false">Back</CButton>
        </div>
      </CModal>
    </CForm>

  </CContainer>
</template>

<script>
import moment from 'moment'

export default {
  name: 'VehicleList',

  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      collapse: false,

      isLoading: false,

      searchValue: "",

      disableVehicleType: false,
      disableFirstTrackTime: false,
      disableLastTrackTime: false,

      isSearching: false,
      
      selected: [],
      options: [
        { item: 'car', name: 'Car' },
        { item: 'truck', name: 'Truck' },
        { item: 'bus', name: 'Bus' },
        { item: 'motorcycle', name: 'Motorcycle' }
      ],

      camera: [],

      showDetailModal: false,

      detail: {
        plate_number: "",
        vehicle_type: "",
        camera: "",
        first_tracked_time: "",
        last_tracked_time: "",
        plate_confidence: "",
        plate_image_in: null,
        vehicle_image_in: null,
        plate_image_out: null,
        vehicle_image_out: null
      },

      firstTrackTime: {
        periodFrom: {
          value: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
          timeValue: '00:00:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodFrom"
        },
        periodTo: {
          value: today,
          timeValue: '23:59:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodTo"
        },
      },

      lastTrackTime: {
        periodFrom: {
          value: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
          timeValue: '00:00:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodFrom"
        },
        periodTo: {
          value: today,
          timeValue: '23:59:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodTo"
        },
        interval: {
          value: "daily",
          isValid: null,
          isRequired: true,
          options: [
            { value: "daily", text: "Daily" },
            { value: "hourly", text: "Hourly" },
            { value: "by_minute", text: "Minute" },
          ],
          payloadKey: "interval"
        },
      },

      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        totalViewText: '',
        isLoaded: true,
        fields: [
          {key: "index", label: "No.", sortable: false},
          {key: "plate_number", label: "Plate Number", sortable: true},
          {key: "vehicle_type", label: "Type", sortable: true},
          {key: "start_detected", label: "First Tracked Time", sortable: true },
          {key: "end_detected", label: "Last Tracked Time", sortable: true },
          {key: "actions", label: "Actions", sortable: false, class:"custom-column-action-user"},
        ],

        items: [],
        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    trackItem(plate){
      this.$router.push({
        name: 'VehicleTracker',
        params: {
          plate_number: plate
        }
      });
    },

    searchVehicle() {
      this.isLoading = true
      this.table.items = []

      // URL builder
      let postUrl = "/vehicle_list"
      let vehicle_type = null
      let first_tracked_time = null
      let last_tracked_time = null

      if (this.disableVehicleType) {
        if (this.selected.length != 0) {
          let car_selected = false
          let truck_selected = false
          let bus_selected = false
          let motorcycle_selected = false

          for (var x = 0; x < this.selected.length; x++) {
            if (this.selected[x] == "car") car_selected = true
            if (this.selected[x] == "truck") truck_selected = true
            if (this.selected[x] == "bus") bus_selected = true
            if (this.selected[x] == "motorcycle") motorcycle_selected = true
          }

          vehicle_type = {
            car: car_selected,
            truck: truck_selected,
            bus: bus_selected,
            motorcycle: motorcycle_selected
          }
        } 
      }

      if (this.disableFirstTrackTime) {
        first_tracked_time = {
          from: this.firstTrackTime.periodFrom.value + ' ' + this.$helper.showData(this.firstTrackTime.periodFrom.timeValue, "longTime"),
          to: this.firstTrackTime.periodTo.value + ' ' + this.$helper.showData(this.firstTrackTime.periodTo.timeValue, "longTime"),
        }
      }

      if (this.disableFirstTrackTime) {
        last_tracked_time = {
          from: this.lastTrackTime.periodFrom.value + ' ' + this.$helper.showData(this.lastTrackTime.periodFrom.timeValue, "longTime"),
          to: this.lastTrackTime.periodTo.value + ' ' + this.$helper.showData(this.lastTrackTime.periodTo.timeValue, "longTime"),
        }
      }

      let obj = {
        search_value: this.searchValue,
        filter: {
          vehicle_type: vehicle_type,
          first_tracked_time: first_tracked_time,
          last_tracked_time: last_tracked_time
        }
      }

      this.$axios.post(postUrl, obj).then(response => {
        if(response.status == 200){
          if (response.data.success) {
            this.table.items = response.data.data
            this.table.totalRows = response.data.data.length
            this.table.totalPages = response.data.data.length % this.table.perPage
          } else{
            this.$helper.toastError(this, "Pencarian kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        } else{
          this.$helper.toastError(this, "Pencarian kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Pencarian kendaraan gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Pencarian kendaraan gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    getDetail(item) {
      this.isLoading = true

      // URL builder
      let postUrl = "/vehicle_list_detail"
      let obj = {
        plate_number: item.plate_number
      }

      this.$axios.post(postUrl, obj).then(response => {
        if(response.status == 200){
          if (response.data.success) {
            let data = response.data.data

            this.detail.plate_number = item.plate_number
            this.detail.vehicle_type = item.vehicle_type.charAt(0).toUpperCase() + item.vehicle_type.slice(1)
            this.detail.first_tracked_time = item.start_detected
            this.detail.last_tracked_time = item.end_detected

            for (var x = 0; x < this.camera.length; x++) {
              if (this.camera[x].value == data.camera_id[0]) {
                this.detail.camera = this.camera[x].text
                break;
              }
            }

            this.detail.plate_confidence = ((data.plate_number_confidence) * 100) + "%"
            this.detail.plate_image_in = data.plate_image_in
            this.detail.plate_image_out = data.plate_image_out
            this.detail.vehicle_image_in = data.vehicle_image_in
            this.detail.vehicle_image_out = data.vehicle_image_out

            this.showDetailModal = true
            
          } else{
            this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        } else{
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    getCameras() {
      // URL builder
      let getUrl = "/cameras"

      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          let data = response.data.data
          for (var x = 0; x < data.length; x++) {
            this.camera.push({
              value: data[x].id, 
              text: data[x].name
            })
          }
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Camera Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Camera Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Camera Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

    
    recalculate() {
      let pg = this.table.currentPage - 1

      let prev = pg * this.table.perPage + 1
      let limit = pg * this.table.perPage + this.table.perPage
      if (limit > this.table.totalRows) limit = this.table.totalRows
      if (this.table.totalRows == 0) prev = 0
      this.table.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.table.totalRows + " entri"
    }
  },
  computed: {
    totalRows() {
      return this.table.totalRows;
    },
    currentPage() {
      return this.table.currentPage;
    }
  },
  watch: {

    totalRows(newVal) {
      this.recalculate()
    },

    currentPage(newVal) {
      this.recalculate()
    },

  },
  created() {
    this.getCameras()
  }
}
</script>

<style>

</style>
